import { Customer } from 'server/shared/models/customer';
import { PoolerUser } from 'server/shared/models/user';
import { PoolerCustomerMap } from 'server/shared/helpers/PoolerMap';
import { PreparedEmploymentPoolerUser } from '../../types/employment/PreparedEmploymentPoolerUser';
import { getEmploymentCustomerTariff } from '../getCustomerTariff';
import { getUserHasBlacklistedDepartment } from '../getUserHasBlacklistedJobDepartment';
import {
  AvailabilityMatchPercentageRange,
  getAvailabilityMatchPercentage,
} from './getAvailabilityMatchPercentage';

export function prepareEmploymentUser(
  user: PoolerUser,
  matchPercentageRange: AvailabilityMatchPercentageRange,
  workload: number,
  currentCustomer: Customer,
  poolerMap: PoolerCustomerMap,
  departmentId: string,
): PreparedEmploymentPoolerUser {
  const preparedUser: PreparedEmploymentPoolerUser = {
    ...user,
    matchPercentage: getAvailabilityMatchPercentage(
      user.employmentAvailabilityDays || [],
      matchPercentageRange,
      workload,
    ),
  };
  const customerOfUser = poolerMap.getCustomerOfUser(user._id);
  if (customerOfUser && customerOfUser?._id !== currentCustomer._id) {
    preparedUser.originCustomer = {
      id: customerOfUser._id,
      displayName: customerOfUser.name,
      tariff: getEmploymentCustomerTariff(
        currentCustomer,
        customerOfUser._id,
        user.certificates || [],
      ),
    };
  }
  preparedUser.hasBlacklistedJobDepartment = getUserHasBlacklistedDepartment(
    departmentId,
    user,
  ).hasBlacklistedJobDepartment;
  return preparedUser;
}
